import { useEffect } from 'react';

/** Keys typed here belong to the control, not the viewer (a video's ← and → seek, say). */
function ownsArrowKeys(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT', 'VIDEO', 'AUDIO'].includes(target.tagName);
}

/** ← and → step through a viewer (a lightbox) while it's open. */
export function useArrowKeyNav({
  open,
  index,
  count,
  onIndexChange,
}: {
  open: boolean;
  index: number;
  count: number;
  onIndexChange: (index: number) => void;
}): void {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.altKey || event.ctrlKey || event.metaKey || ownsArrowKeys(event.target)) return;
      if (event.key === 'ArrowLeft' && index > 0) {
        event.preventDefault();
        onIndexChange(index - 1);
      } else if (event.key === 'ArrowRight' && index < count - 1) {
        event.preventDefault();
        onIndexChange(index + 1);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [count, index, onIndexChange, open]);
}
